import React from 'react';
import { Modal } from '../../ui/Modal';

interface ScreenSharePromptModalProps {
  open?: boolean;
  /** User-facing reason string the AI provided. */
  reason: string;
  onAccept: () => void;
  onDecline: () => void;
}

/**
 * Consent modal shown when hollie calls `request_screen_share`.
 * Stateless - parent (CallScreen) owns the pending-request state.
 */
export const ScreenSharePromptModal: React.FC<ScreenSharePromptModalProps> = ({
  open = true,
  reason,
  onAccept,
  onDecline,
}) => (
  <Modal open={open} onClose={onDecline}>
    <div className="text-center space-y-6">
      <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center mb-2 bg-volt/20">
        <svg
          className="w-8 h-8 text-accent-soft"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </div>

      <div>
        <h3 className="text-xl font-bold text-foreground mb-2">Can hollie see your screen?</h3>
        <p className="text-muted-foreground">
          {reason || 'So she can understand exactly what you mean.'}
        </p>
        <p className="text-muted-foreground text-sm mt-3">
          You can stop sharing at any time, and hollie will close the share herself once she's seen enough.
        </p>
      </div>

      <div className="space-y-3">
        <button
          onClick={onAccept}
          className="block w-full font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-[1.02] button-accent"
        >
          Share my screen
        </button>

        <button
          onClick={onDecline}
          className="block w-full bg-surface hover:bg-surface-hover text-foreground font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          Not now
        </button>
      </div>
    </div>
  </Modal>
);
